export function setEditing<R>(
    columns: any[],
    onSave: (record: R, formValues: any) => void,
    isRowEditable?: (record: R) => boolean
): any[] {
    const mapColumn = (item: any) => {
        if (item.children) {
            return { ...item, children: setEditing(item.children, onSave) }
        }

        const getInitialProps = (record: any, index: number) =>
            item.onCell ? item.onCell(record, index) : {}

        if (item.editable) {
            return {
                ...item,
                onCell: (record: any, index: number) => {
                    const initialProps = getInitialProps(record, index)
                    const baseEditable = initialProps.editable ?? item.editable
                    const editable = isRowEditable ? baseEditable && isRowEditable(record) : baseEditable

                    return {
                        ...initialProps,
                        record,
                        title: item.title,
                        dataIndex: initialProps.dataIndex ?? item.dataIndex,
                        editable,
                        FormItem: item.FormItem,
                        handleSave: onSave,
                        relationPath: initialProps.relationPath ?? item.relationPath,
                        validator: item.validator,
                        fieldDescriptors: initialProps.fieldDescriptors ?? item.fieldDescriptors,
                    }
                },
            }
        }

        if (item.validator) {
            return {
                ...item,
                onCell: (record: any, index: number) => {
                    const initialProps = getInitialProps(record, index)

                    return {
                        ...initialProps,
                        record,
                        title: item.title,
                        dataIndex: item.dataIndex,
                        editable: false,
                        validator: item.validator,
                    }
                },
            }
        }

        return item
    }

    return columns.map(mapColumn)
}
